import React from 'react';
import { NavigationRoute } from '../../../api/Navigation';
import { AuthenticationState } from '../../../api/constants';
import Auth0AuthenticatedRoute from './Auth0AuthenticatedRoute';
import Auth0UnauthenticatedRoute from './Auth0UnauthenticatedRoute';

export type RouteWrapperProps = NavigationRoute;

const RouteWrapper: React.FC<RouteWrapperProps> = (props) => {
  const RouteMapper = {
    [AuthenticationState.AUTH0_AUTHENTICATED]: Auth0AuthenticatedRoute,
    [AuthenticationState.AUTH0_UNAUTHENTICATED]: Auth0UnauthenticatedRoute,
  };

  const Route = RouteMapper[props.authState];

  return <Route {...props} />;
};

export default RouteWrapper;
